import Vue from 'vue';
import PromotionService from '@/services/PromotionService';
import { constant } from '@/utils/helper';
const { PROMOTION } = constant;

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
const DEFAULT_TIME_FORMAT = 'HH:mm:ss';

const isInDuration = (promotion, orderTime) => {
  const { $dayjs } = Vue.prototype;
  const current = orderTime ? $dayjs(orderTime) : $dayjs();
  const fromDate = $dayjs(promotion.fromDate, DEFAULT_DATE_FORMAT);
  let toDate = $dayjs(promotion.toDate, DEFAULT_DATE_FORMAT).endOf('day');
  let startTime = $dayjs(promotion.startTime, "HH:mm:ss");
  startTime.date(current.date())
  let endTime = $dayjs(promotion.endTime, "HH:mm:ss");
  endTime.date(current.date())
  const dayOfWeek = JSON.parse(promotion.dayOfWeek);
  let currentWeekDayName = $dayjs().format('ddd');
  
  if (endTime.isBefore(startTime)) {
    if (current.isBefore(startTime)) {
      startTime = startTime.subtract(1, 'day');
      currentWeekDayName = $dayjs().subtract(1, 'day').format('ddd');
    } else {
      endTime = endTime.add(1, 'day');
    }
    toDate = toDate.add(1, 'day');
  }
  return current.isBetween(fromDate, toDate, null, '[]')
      && current.isBetween(startTime, endTime)
      && dayOfWeek.includes(currentWeekDayName);
};

// state
const localState = {
  autoLoad: {
    loading: false,
    loader: PromotionService.list,
    emptyMap: {},
  },
  promotions: {},
  promotionTypes: {
    '1': { name: 'Buy X Get Y', id: PROMOTION.BUY_X_GET_Y },
    '2': { name: 'Discount %', id: PROMOTION.DISCOUNT_PERCENT },
    '3': { name: 'Special price', id: PROMOTION.SPECIAL_PRICE },
    '4': { name: 'Discount price', id: PROMOTION.DISCOUNT_PRICE },
    '5': { name: '100% discount on everything', id: PROMOTION.FREE_ALL },
  },
  customerTypes: {},
  weekdays: {
    '1': { name: 'Mon', id: 'Mon' },
    '2': { name: 'Tue', id: 'Tue' },
    '3': { name: 'Wed', id: 'Wed' },
    '4': { name: 'Thu', id: 'Thu' },
    '5': { name: 'Fri', id: 'Fri' },
    '6': { name: 'Sat', id: 'Sat' },
    '7': { name: 'Sun', id: 'Sun' },
  },
};

// getters
const localGetters = {
  getActivePromotions: (state, getters) => (orderTime) => {
    const promotions = [];
    const allPromotions = getters.getArray('promotions');
    const bill = getters.getMap('bill', true);
    const customer = bill.customer ? getters.getObject(bill.customer, 'customers') : null;
    allPromotions.forEach((promotion) => {
      let isCustomerType = true;
      if(promotion.customerType
          && (!customer
              || promotion.customerType != customer.customerType)) {
        isCustomerType = false;
      }
      if (promotion.active && isInDuration(promotion, orderTime) && isCustomerType) {
        promotions.push(promotion);
      }
    });
    promotions.sort((a, b) => {
      if (a.priority === null) {
        return 1;
      } else if (b.priority === null) {
        return -1;
      }
      return a.priority - b.priority;
    });

    return promotions;
  },
  getPromotionByArticle: (state, getters) => (article) => {
    const activePromotions = getters.getActivePromotions(article.orderTime);
    const promotion = activePromotions
                      .find(promotion => 
                        promotion.products.includes(article.id) 
                        || promotion.promotionType == PROMOTION.FREE_ALL
                      );
    return promotion;
  },
  getPromotionPrice: () => (promotion, originalPrice) => {
    if (!promotion) return originalPrice;

    switch (promotion.promotionType) {
      case PROMOTION.DISCOUNT_PERCENT:
        return originalPrice * (100 - promotion.value) / 100;
      case PROMOTION.SPECIAL_PRICE:
        return promotion.value;
      case PROMOTION.DISCOUNT_PRICE:
        return originalPrice - promotion.value;
      case PROMOTION.FREE_ALL:
        return 0;
      default:
        return originalPrice;
    }
  },
  isBuyXGetYPromotion: () => promotion => promotion && promotion.promotionType === PROMOTION.BUY_X_GET_Y,
  calRemainGetY: () => (promotion, currentBuyX = 0, currentGetY = 0) => {
    if (!promotion
      || !currentBuyX
      || currentBuyX < promotion.value
    ) {
      return 0;
    }

    const block = Math.floor(currentBuyX / promotion.value);
    return promotion.subValue * block - currentGetY;
  },
  getPromotionByName: (state) => (promotionName) => {
    for (const id in state.promotions) {
      if(state.promotions[id].name == promotionName) {
        return state.promotions[id];
      }
    }
    return null;
  }
};

// mutations
const mutations = {
};

// actions
const actions = {
};

export default {
  state: localState,
  getters: localGetters,
  mutations,
  actions,
};
